var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a7-painel"},[_c(_vm.menuComponent,{tag:"component",attrs:{"itens":_vm.itens,"filtrosAtivos":_vm.filtros},on:{"filtrou":_vm.setFiltros,"agrupou":_vm.setAgrupamento}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }